import React, { Component } from 'react';
import cx from 'classnames';
import { connect } from 'react-redux';
// import CROSS from 'assets/images/close.png';
import './style.scss';

class Toast extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { toast } = this.props;
    return (
      <div
        className={cx('toast', {
          visible: toast.visible,
        })}
        style={{
          backgroundColor: toast.color,
        }}
        onClick={() => {
          this.props.dispatch({ type: 'TOAST_HIDE' });
        }}
      >
        <h2>{toast.text}</h2>
      </div>
    );
  }
}

const select = ({ toast }) => ({ toast });
const Connected = connect(select)(Toast);
export { Connected as Toast };



// WEBPACK FOOTER //
// ./src/view/common/Toast/index.js